var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Staffonly"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLSeGh74WXVxTqpJht4V39aZGVn8MnCuraNmfjhFz4DMYuvssBg/viewform?embedded=true","width":"100%","height":"100%","min-height":"100%"}},[_vm._v("載入中…")])])
}]

export { render, staticRenderFns }